import Page from 'modules/WgsAbout'

export default Page

